const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMuseumBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "museum",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 171.47 126.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "b54242d1-e5ab-4cdf-bd21-1bd148e435ad",
    "data-name": "border",
    d: "M.34,67.1,33.4,56.17l-.87-1.58s1.7-1.94,1.78-2.64,0-11.41,0-11.41h5.16v-7h4.6V26.47h5.18V20h4.93v-7h4.47V7H63.7L63.57.41l8.7-.16V6.53l4.74,0,0,6.87h5v6.49h5.51v6.6h5.12V33h5v6.52h4.91v11.1l2.7,4h-2.1V68l61.64,10.87L161,82.37s.11,32.84.22,32.46,4.53,1.32,5.39,2.58,3.42-.33,4.3,1.54-.22,5-1.43,5.22-137.5,2-137.5,2-.23-1.66-1-1.67H3.12V71.06H.26Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuseumBorder);
export default __webpack_public_path__ + "static/media/museum-border.1c61c3696c2f83c8da54474602fb5f48.svg";
export { ForwardRef as ReactComponent };